/** @format */

import { Box, Button, Flex, Spinner } from "@chakra-ui/react";
import { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { CardCashbackHorizontal } from "../../../components/CardCashback/Horizontal";
import { CardDescontoExclusivoHorizontal } from "../../../components/CardDescontoExclusivo/Horizontal";
import { CardInfoOfertasExclusivas } from "../../../components/CardInfoOfertasExclusivas";
import { CardOfertaHorizontal } from "../../../components/CardOferta/Horizontal";
import { EmptyState } from "../../../components/EmptyState";
import { FiltrosList } from "../../../components/FiltrosList";
import { Header } from "../../../components/Header";
import { LojaButton } from "../../../components/LojaButton";
import { SearchInput } from "../../../components/SearchInput";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { useSession } from "../../../context/useSession";
import { formatRecomendacao, removeAcento } from "../../../utils";
import { Lojas } from "../Lojas";
import { useToast } from "@chakra-ui/react";
import { Virtuoso } from "react-virtuoso";
import debounce from "lodash.debounce";
import { ModalMsg } from "../../../components/ModalMsg";

export function VerMais() {
  const toast = useToast();
  const virtuoso = useRef(null);
  const { idtiporecomendacao } = useParams();
  const history = useHistory();
  const {
    recomendacao,
    filteredRecomendacao,
    selectedFiltros,
    requestRecomendacao,
    selectedOrder,
    ordernaProdutos,
    loja,
    viewDescricao,
    ativaTodosDescontos,
  } = useRecomendacao();
  const {
    personalizacao: { guiaofertas, vermais },
  } = usePersonalizacao();
  const { session, setSession } = useSession();

  const [isModalLojaOpen, setIsModalLojaOpen] = useState(false);

  const { ofertas, descontoExclusivo, dinheiroDeVolta, destaques } = formatRecomendacao(
    selectedFiltros.length > 0 ? filteredRecomendacao : recomendacao,
    guiaofertas?.hasDestaques, guiaofertas?.ordenacaoRecomendacao
  );
  const [produtos, setProdutos] = useState([]);
  const [productsFound, setProductsFound] = useState([]);

  const [inputSearch, setInputSearch] = useState("");

  const [loadingBotaoAtivarTodasOfertas, setLoadingBotaoAtivarTodasOfertas] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  useEffect(() => {
    if (
      session.redirect !== "" &&
      (session.redirect === window.location.pathname.split("/")[1]) === "vermais"
    ) {
      setSession({ ...session, redirect: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    defineTipoProdutos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrder, recomendacao, filteredRecomendacao, session]);

  useEffect(() => {
    window.scroll(0, 0);
    if (virtuoso.current) {
      virtuoso.current.scrollToIndex({
        index: 0,
        align: "start",
        behavior: "smooth",
      });
    }
  }, [selectedFiltros, selectedOrder]);

  useEffect(() => {
    if (inputSearch.length >= 2) {
      let text = removeAcento(inputSearch.toUpperCase());
      let filteredData = produtos.filter((item, index) => {
        let itemName = item.produto ? item.produto.toUpperCase() : item.nomeoferta.toUpperCase();
        itemName = removeAcento(itemName);

        return itemName.indexOf(text) > -1;
      });
      setProductsFound(filteredData);
    } else {
      setProductsFound(produtos);
    }
  }, [inputSearch, produtos]);

  useEffect(() => {
    return () => debouncedResults.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChange(e) {
    setInputSearch(e.target.value);
  }

  const debouncedResults = useMemo(() => {
    return debounce(handleChange, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defineTipoProdutos = () => {
    if (recomendacao.length === 0 && session.idvarejista) {
      requestRecomendacao();
    }
    if (idtiporecomendacao === "4") {
      setProdutos(ordernaProdutos(selectedOrder.length > 0 ? selectedOrder[0].id : 0, destaques));
    } else if (idtiporecomendacao === "2") {
      setProdutos(ordernaProdutos(selectedOrder.length > 0 ? selectedOrder[0].id : 0, ofertas));
    } else if (idtiporecomendacao === "1") {
      setProdutos(ordernaProdutos(selectedOrder.length > 0 ? selectedOrder[0].id : 0, descontoExclusivo));
    } else {
      setProdutos(ordernaProdutos(selectedOrder.length > 0 ? selectedOrder[0].id : 0, dinheiroDeVolta));
    }
  };

  const ProdutosView = ({ index, data }) => {
    if (idtiporecomendacao === "4") {
      return (
        <Box paddingX="1rem" paddingBottom={index === productsFound.length - 1 ? "3.5rem" : 0}>
          <Box key={data.idoferta} marginY="1.5rem">
            {data.idtiporecomendacao === "1" && (
              <CardDescontoExclusivoHorizontal
                onClickCard={
                  !data.linkproduto
                    ? () => {
                        history.push(`/descricao/1/${data.idoferta}`);
                        viewDescricao(data);
                      }
                    : () => {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({
                            title: data.nomeoferta.slice(0, 30),
                            url: data.linkproduto,
                          })
                        );
                        viewDescricao(data);
                      }
                }
                props={data}
              />
            )}
            {data.idtiporecomendacao === "2" && (
              <CardOfertaHorizontal
                onClickCard={
                  !data.linkproduto
                    ? () => {
                        history.push(`/descricao/2/${data.idoferta}`);
                        viewDescricao(data);
                      }
                    : () => {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({
                            title: data.nomeoferta.slice(0, 30),
                            url: data.linkproduto,
                          })
                        );
                        viewDescricao(data);
                      }
                }
                props={data}
              />
            )}
            {data.idtiporecomendacao === "3" && (
              <CardCashbackHorizontal
                onClickCard={
                  !data.linkproduto
                    ? () => {
                        history.push(`/descricao/1/${data.idoferta}`);
                        viewDescricao(data);
                      }
                    : () => {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({
                            title: data.nomeoferta.slice(0, 30),
                            url: data.linkproduto,
                          })
                        );
                        viewDescricao(data);
                      }
                }
                props={data}
              />
            )}
          </Box>
        </Box>
      );
    }

    if (idtiporecomendacao === "2") {
      return (
        <Box paddingX="1rem" paddingBottom={index === productsFound.length - 1 ? "3.5rem" : 0}>
          <Box key={data.idoferta} marginY="1.5rem">
            <CardOfertaHorizontal
              onClickCard={
                !data.linkproduto
                  ? () => {
                      history.push(`/descricao/2/${data.idoferta}`);
                      viewDescricao(data);
                    }
                  : () => {
                      window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                          title: data.nomeoferta.slice(0, 30),
                          url: data.linkproduto,
                        })
                      );
                      viewDescricao(data);
                    }
              }
              props={data}
            />
          </Box>
        </Box>
      );
    }

    if (idtiporecomendacao === "3") {
      return (
        <Box paddingX="1rem" paddingBottom={index === productsFound.length - 1 ? "3.5rem" : 0}>
          <Box key={data.idoferta} marginY="1.5rem">
            <CardCashbackHorizontal
              onClickCard={
                !data.linkproduto
                  ? () => {
                      history.push(`/descricao/3/${data.idoferta}`);
                      viewDescricao(data);
                    }
                  : () => {
                      window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                          title: data.nomeoferta.slice(0, 30),
                          url: data.linkproduto,
                        })
                      );
                      viewDescricao(data);
                    }
              }
              props={data}
            />
          </Box>
        </Box>
      );
    }

    if (idtiporecomendacao === "1") {
      return (
        <Box paddingX="1rem" paddingBottom={index === productsFound.length - 1 ? "3.5rem" : 0}>
          <Box key={data.idoferta} marginY="1.5rem">
            <CardDescontoExclusivoHorizontal
              onClickCard={
                !data.linkproduto
                  ? () => {
                      history.push(`/descricao/1/${data.idoferta}`);
                      viewDescricao(data);
                    }
                  : () => {
                      window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                          title: data.nomeoferta.slice(0, 30),
                          url: data.linkproduto,
                        })
                      );
                      viewDescricao(data);
                    }
              }
              props={data}
            />
          </Box>
        </Box>
      );
    }
  };

  const ativaTodosOsDescontos = async () => {
    if (!session?.cpfcnpj) {
      setModalMsg("Você precisa estar logado para ativar esta oferta.");
      return;
    }
    setLoadingBotaoAtivarTodasOfertas(true);
    await ativaTodosDescontos();
  };

  useEffect(() => {
    if (
      loadingBotaoAtivarTodasOfertas &&
      recomendacao.filter((data) => data.idtiporecomendacao === "1").length ===
        recomendacao.filter((data) => data.ativado === true).length
    ) {
      toast({
        title: "Ofertas ativadas",
        description: "Todas suas ofertas acabaram de ser ativadas com sucesso, aproveite!",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      setLoadingBotaoAtivarTodasOfertas(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recomendacao]);

  return (
    <Box display="flex" flexDir="column" maxWidth="900px" margin="0 auto" background="white" overflow="hidden" h="100vh">
      <Box
        // height={`calc(100vh - ${
        //   Number(document.getElementById("header-filters")?.clientHeight)
        // }px - ${(vermais?.cardDescontosAtivados === true || vermais?.cardDescontosAtivados === undefined) ? (idtiporecomendacao === "1" ? document.getElementById("descontos-card")?.clientHeight : 0) : 0}px)`}
        height={"100%"}
        background={
          guiaofertas.background !== undefined
            ? guiaofertas.background
              ? guiaofertas.background
              : "#EDEEF2"
            : "#EDEEF2"
        }
        marginBottom="0.75rem"
        display="flex"
        flexDir="column"
      >
          <Box
            flexDir="column"
            id="header-filters"
            position="relative"
            boxSizing="border-box"
            display="flex"
            background={guiaofertas.headerbackground}
            // top={0}
          >
            <Box w="100%" overflowY="hidden">
              <Header />
              <Box paddingX="1rem" background={guiaofertas.headerbackground}>
                <SearchInput
                  placeholder="Pesquisar oferta"
                  _placeholder={[{ color: "#70747D" }]}
                  onFocus={() => {}}
                  onChange={debouncedResults}
                />
              </Box>
              <Box my="0.75rem">
                <FiltrosList />
              </Box>
              <Box px="1rem" my="0.75rem">
                <LojaButton
                  loja={loja.nomeLojaSelecionada || "Selecione uma loja"}
                  onClick={() => setIsModalLojaOpen(true)}
                />
                <Lojas isOpen={isModalLojaOpen} onRequestClose={() => setIsModalLojaOpen(false)} />
              </Box>
            </Box>
          </Box>
          {idtiporecomendacao === "1" &&
            (vermais?.cardDescontosAtivados === true || vermais?.cardDescontosAtivados === undefined) && (
              <Box padding="0.5rem 1rem" id="descontos-card" background="#EDEEF2">
                <CardInfoOfertasExclusivas
                  disponiveis={produtos.filter((data) => data.idtiporecomendacao === "1").length}
                  ativadas={
                    produtos
                      .filter((data) => data.idtiporecomendacao === "1")
                      .filter((data) => data.ativado === true).length
                  }
                />
              </Box>
            )}
          {productsFound.length === 0 && (
            <Box mt="6">
              <EmptyState />
            </Box>
          )}
        <PullToRefresh
          onRefresh={requestRecomendacao}
          resistance={2}
          maxPullDownDistance={70}
          pullingContent={
            <Box display="flex" alignItems="center" justifyContent="center">
              Puxe para atualizar
            </Box>
          }
          refreshingContent={
            <Box display="flex" alignItems="center" justifyContent="center">
              <Spinner color="#0D4E7E" />
            </Box>
          }
        >
          <Flex flexDir="column" height="100%" flex={1}>
            <Virtuoso
              ref={virtuoso}
              style={{
                // height: "auto",
              }}
              className="scroll-virtuoso"
              data={productsFound}
              totalCount={productsFound.length}
              itemContent={(index, productsFound) => <ProdutosView data={productsFound} index={index} />}
            />
          </Flex>
        </PullToRefresh>
      </Box>
      {vermais?.botaoativatodasofertasvisible &&
        (idtiporecomendacao === "1" || idtiporecomendacao === "4") &&
        recomendacao.filter((data) => data.idtiporecomendacao === "1").length >
          recomendacao.filter((data) => data.ativado === true).length && (
          <Box
            maxW="900px"
            w="100%"
            position="fixed"
            bottom={0}
            background="linear-gradient(0deg, rgba(54, 54, 54, 0.85) 0%, rgba(83, 82, 82, 0) 98.96%)"
          >
            <Box height="100%" paddingY={3} display="flex" alignItems="center" justifyContent="center">
              <Button
                background={
                  vermais?.bgbotaoativartodasofertas ? vermais.bgbotaoativartodasofertas : "#186DAF"
                }
                width="70%"
                _hover={[{ opacity: 0.8 }]}
                disabled={loadingBotaoAtivarTodasOfertas}
                color={
                  vermais?.colortextbotaoativartodasofertas
                    ? vermais.colortextbotaoativartodasofertas
                    : "#fff"
                }
                size="md"
                borderRadius="full"
                isLoading={loadingBotaoAtivarTodasOfertas}
                onClick={ativaTodosOsDescontos}
              >
                Ativar todas as ofertas
              </Button>
            </Box>
          </Box>
        )}
      <ModalMsg message={modalMsg} setMessage={setModalMsg} />
    </Box>
  );
}
